export { transformerGa4 } from './transformer';
export { defaultMapping } from './defaults';
export type {
  GA4Settings,
  GA4Mapping,
  GA4Request,
  GA4Hit,
  GA4Event,
  GA4EventParams,
  GA4HitParams,
  GA4Item,
} from './types';
export { transformerGa4 as default } from './transformer';
